import { LDAPAddress, LDAPManagementState, LDAPPort } from "./types";

export function getDefaultState(): LDAPManagementState {
	return {
		ldapAddresses: Array<LDAPAddress>(),
		ldapPort: { port: null },
	};
}
